/** @format */

import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ProductListHeader from "../Common/ProductListHeader";
import ProductListTable from "./ProductList";
import CommonCardHeader from "../../Utils/CommonComponents/CommonCardHeader";
import * as XLSX from "xlsx";
import { getAPIURL, getVendorID } from "../../services/helper";
import http from "../../services/http";
import Swal from "sweetalert2";
import { fetchProducts } from "../../ReduxToolkit/Reducers/ProductsReducer";
import { useDispatch } from "react-redux";
import Loader from "../../Layout/Loader";

const api_url = getAPIURL();
const vendor_id = getVendorID();
export default function ProductListContainer() {
  const { products, isLoading } = useSelector((state) => state.products);
  const dispatch = useDispatch();

  const REQUIRED_COLUMNS = [
    "name",
    "price",
    "sku",
    "regular_price",
    "sale_price",
    "manage_stock",
    "stock_quantity",
    "categories",
    "vendor_id",
  ];

  const handleExport = () => {
    const exportData = products.map((product) => ({
      name: product.name,
      price: product.price,
      sku: product.sku,
      regular_price: product.regular_price,
      sale_price: product.sale_price,
      manage_stock: product.manage_stock ? "yes" : "no",
      stock_quantity: product.stock_quantity,
      categories: (product.categories || []).map((cat) => cat.name).join(","),
      vendor_id,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
    XLSX.writeFile(workbook, "product-export.xlsx");
  };

  const handleImport = async (file) => {
    try {
      Swal.fire({
        title: "Importing...",
        text: "Please wait while products are being imported.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const headerKeys = Object.keys(rows[0] || {});
      const missingColumns = REQUIRED_COLUMNS.filter(
        (col) => !headerKeys.includes(col)
      );

      if (missingColumns.length > 0) {
        Swal.close();
        Swal.fire(
          "Import Failed",
          `Missing columns: ${missingColumns.join(", ")}`,
          "error"
        );
        return;
      }

      const invalidRows = rows.filter((row) => !row.sku);
      if (invalidRows.length > 0) {
        Swal.close();
        Swal.fire(
          "Import Failed",
          `Found ${invalidRows.length} row(s) without SKU.`,
          "error"
        );
        return;
      }

      const payload = { rows, vendor_id };

      const res = await http.post(`${api_url}/products/import`, payload);

      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Import Complete",
        html: `
          <ul style="text-align:left;line-height:1.8">
            <li><b>✅ Imported/Updated:</b> ${res.data.imported}</li>
            <li><b>🗑️ Deleted:</b> ${res.data.deleted || 0}</li>
            <li><b>⛔ Skipped:</b> ${res.data.skipped}</li>
          </ul>
        `,
        timer: 5000,
        showConfirmButton: false,
      });

      dispatch(fetchProducts()); // or whatever action you use
    } catch (err) {
      console.error("Import error:", err);
      Swal.close();
      Swal.fire("Import Error", "Check console for more details.", "error");
    }
  };

  return (
    <div className="page-body main-project">
      {isLoading && <Loader />}
      <Container fluid>
        <Row>
          <Col sm={12}>
            <Card>
              <CommonCardHeader title="All Products" />
              <CardBody>
                <ProductListHeader
                  linkTitle="Add Product"
                  onExport={handleExport}
                  onImport={handleImport}
                />
                <ProductListTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
